import React from "react";
import { Box, Typography, Button } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useNavigate } from "react-router-dom";

const ThankYouPage = () => {
  const navigate = useNavigate();

  const handleGoBackHome = () => {
    navigate("/biochar-campaign");
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          p: 4,
          borderRadius: 2,
          maxWidth: 400,
        }}
      >
        <CheckCircleOutlineIcon
          sx={{
            fontSize: "64px",
            color: "#4caf50",
            mb: 2,
          }}
        />

        <Typography variant="h4" component="h1" sx={{ mb: 2 }}>
          Thank You!
        </Typography>

        <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
          Thank you for showing interest, our team will get back to you with
          more details
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={handleGoBackHome}
          sx={{ mt: 2, color: "white" }}
        >
          Back to Home
        </Button>
      </Box>
    </Box>
  );
};

export default ThankYouPage;
